import {
    KEYSFOBS_DELETE_OPEN_MODAL,
    KEYSFOBS_DELETE_REQUEST,
    KEYSFOBS_DELETE_RESULT
} from 'Redux/actionTypes';

export const keyfobsDeleteRequest = (id, hex) => ({
    type: KEYSFOBS_DELETE_REQUEST,
    payload: { id, hex }
})

export const keyfobsDeleteResult = (result) => ({
    type: KEYSFOBS_DELETE_RESULT,
    payload: result
})

export const keyfobsDeleteOpenModal = (keyfob) => ({
    type: KEYSFOBS_DELETE_OPEN_MODAL,
    payload: keyfob
})